import { format } from 'date-fns/format'
import { isValid } from 'date-fns/isValid'
import { parseISO } from 'date-fns/parseISO'

import { parseServiceDate } from './MenuHeader/ServiceSelectionGraphql/serviceWeeks'

// Delivery clocks and URL parameters use the account location timezone when available.
export function formatTimeslotTime(value?: string | null, timezone?: string | null): string {
  const date =
    value === undefined
      ? new Date()
      : value === null
        ? new Date(NaN)
        : timezone
          ? parseServiceDate(value, timezone)
          : parseISO(value)
  if (!isValid(date)) return 'Invalid date'
  // Intl formats the instant directly without constructing a browser-local wall clock,
  // which could land in the browser's own DST gap.
  return timezone
    ? new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).format(date)
    : format(date, 'HH:mm')
}

export function parseTimeslotUrlDate(
  date: string,
  clock: string,
  timezone?: string | null,
): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(clock)) return null
  const value = `${date}T${clock}:00`
  const parsed = timezone ? parseServiceDate(value, timezone) : parseISO(value)
  return isValid(parsed) ? parsed.toISOString() : null
}
